import React from 'react';
import { CircleNotch, Plus } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import { PAYER_LABELS, PAYER_ORDER } from './usePayerContracts';

const NewContractDialog = ({
  open, onOpenChange,
  newContractPayer, setNewContractPayer,
  newContractForm, setNewContractForm,
  saving, onSave,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle style={{ fontFamily: 'Manrope' }}>New Payer Contract</DialogTitle>
        <DialogDescription>
          Create a contract with Ohio standard rates pre-loaded. Rates can be edited after creation.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Payer *</Label>
          <Select value={newContractPayer} onValueChange={setNewContractPayer}>
            <SelectTrigger data-testid="new-contract-payer">
              <SelectValue placeholder="Select payer" />
            </SelectTrigger>
            <SelectContent>
              {PAYER_ORDER.map((p) => (
                <SelectItem key={p} value={p}>{PAYER_LABELS[p] || p}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>Contract Name *</Label>
          <Input
            value={newContractForm.contract_name}
            onChange={(e) =>
              setNewContractForm((prev) => ({ ...prev, contract_name: e.target.value }))
            }
            placeholder="e.g., ODM FY2026 Rates"
            data-testid="new-contract-name"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Start Date *</Label>
            <Input
              type="date"
              value={newContractForm.start_date}
              onChange={(e) =>
                setNewContractForm((prev) => ({ ...prev, start_date: e.target.value }))
              }
              data-testid="new-contract-start"
            />
          </div>
          <div className="space-y-2">
            <Label>End Date</Label>
            <Input
              type="date"
              value={newContractForm.end_date}
              onChange={(e) =>
                setNewContractForm((prev) => ({ ...prev, end_date: e.target.value }))
              }
              data-testid="new-contract-end"
            />
            <p className="text-xs text-slate-400">Leave empty for ongoing</p>
          </div>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={onSave}
          disabled={saving}
          className="bg-indigo-900 hover:bg-indigo-800"
          data-testid="save-new-contract-btn"
        >
          {saving ? <CircleNotch size={16} className="mr-2 animate-spin" /> : <Plus size={16} className="mr-2" />}
          Create Contract
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default NewContractDialog;
